import { FC } from "react";

import { lensConfigurationSteps } from "@/apiUtils/constants";
import { ConfiguratorStepProps, StepOptions, TranslationData } from "@/common/lib/types";
import Divider from "../ui/divider/Divider";
import LensSummary from "./components/lensSummary/LensSummary";
import Help from "./lcpHeader/Help";
import LCPHeader from "./lcpHeader/LCPHeader";
import AdditionalFeatures from "./phaseOne/additionalOptions/AdditionalOptions";
import LensCustomize from "./phaseOne/lensCustomize/LensCustomize";
import LensType from "./phaseOne/lensType/LensType";
import SavedPrescription from "./phaseOne/prescription/saved/SavedPrescription";
import UploadPrescription from "./phaseOne/prescription/upload/UploadPrescription";
import ReviewAndPrescription from "./phaseTwo/reviewAndPrescription/ReviewAndPrescription";

interface LensConfiguratorViewProps {
  locale: string;
  stepOptions: any;
  currentStep: string;
  currencyCode: string;
  localLoading: boolean;
  translations: TranslationData;
  onCloseLensConfigurator: () => void;
  handleAddToCart: ConfiguratorStepProps["handleAddToCart"];
  handleJumpToStep: (step: lensConfigurationSteps) => Promise<void>;
  handleStepData: (step: lensConfigurationSteps, data: any) => Promise<void>;
}

interface ConfiguratorProps extends ConfiguratorStepProps {
  currentStep: string;
  stepOptions: StepOptions;
  onCloseLensConfigurator: () => void;
}

const steps: Record<string, React.ComponentType<any>> = {
  [lensConfigurationSteps.LENS_TYPE]: LensType,
  [lensConfigurationSteps.REVIEW]: ReviewAndPrescription,
  [lensConfigurationSteps.ADD_TO_CART]: ReviewAndPrescription,
  [lensConfigurationSteps.PRESCRIPTION]: SavedPrescription,
  [lensConfigurationSteps.LENS_CUSTOMIZATION]: LensCustomize,
  [lensConfigurationSteps.ADDITIONAL_OPTIONS]: AdditionalFeatures,
  [lensConfigurationSteps.UPLOAD_PRESCRIPTION]: UploadPrescription,
};

const LensConfiguratorView: FC<LensConfiguratorViewProps> = ({
  locale,
  currentStep,
  stepOptions,
  currencyCode,
  translations,
  localLoading,
  handleStepData,
  handleAddToCart,
  handleJumpToStep,
  onCloseLensConfigurator,
}) => {
  return (
    <section className="container mb-10 py-0 md:px-12">
      <LCPHeader onClose={onCloseLensConfigurator} translations={translations} locale={locale} />
      {!localLoading && (
        // <section className="grid grid-cols-12">
        // <LensSummary
        //   locale={locale}
        //   translations={translations}
        //   currencyCode={currencyCode}
        //   onJumpToStep={handleJumpToStep}
        //   onCloseLensConfigurator={onCloseLensConfigurator}
        // />
        //   <>
        // <Divider
        //   position="vertical"
        //   containerClassName="hidden lg:flex lg:col-span-1 w-fit h-full rtl:mr-0 rtl:lg:mr-[3rem] lg:mx-12"
        //   // containerClassName="hidden lg:flex lg:col-span-1 h-full lg:mx-12"
        // />
        //     <div className="border border-black lg:col-span-7">
        // <section
        // // className="col-span-7"
        //  className="col-span-full mt-2 border border-black lg:col-span-7 lg:mt-0 ltr:-ml-0 ltr:lg:-ml-[4rem]"
        //  >
        //   <Configurator
        //     locale={locale}
        //     currentStep={currentStep}
        //     stepOptions={stepOptions}
        //     translations={translations}
        //     currencyCode={currencyCode}
        //     handleStepData={handleStepData}
        //     handleAddToCart={handleAddToCart}
        //     handleJumpToStep={handleJumpToStep}
        //   />
        // </section>
        //     </div>
        //   </>
        // </section>
        <section className="grid w-full grid-cols-1 items-start lg:gap-11 lg:grid-cols-[461px_1px_1fr]">
          <LensSummary
            locale={locale}
            translations={translations}
            currencyCode={currencyCode}
            onJumpToStep={handleJumpToStep}
            onCloseLensConfigurator={onCloseLensConfigurator}
          />
          <Divider
            position="vertical"
            containerClassName="hidden lg:flex justify-center items-stretch w-full h-full"
          />
          <section className="mt-2 w-full lg:mt-0">
            <Configurator
              locale={locale}
              currentStep={currentStep}
              stepOptions={stepOptions}
              translations={translations}
              currencyCode={currencyCode}
              handleStepData={handleStepData}
              handleAddToCart={handleAddToCart}
              handleJumpToStep={handleJumpToStep}
              onCloseLensConfigurator={onCloseLensConfigurator}
            />
          </section>
        </section>
      )}
      {!localLoading && (
        <Help
          locale={locale}
          translations={translations}
          className="mt-9 flex items-center justify-center lg:hidden"
        />
      )}
    </section>
  );
};

const Configurator: FC<ConfiguratorProps> = ({
  locale,
  currentStep,
  stepOptions,
  currencyCode,
  translations,
  handleStepData,
  handleAddToCart,
  handleJumpToStep,
  onCloseLensConfigurator,
}) => {
  const StepComponent = steps[currentStep] || LensType;
  return (
    <StepComponent
      locale={locale}
      stepOptions={stepOptions}
      translations={translations}
      currencyCode={currencyCode}
      handleStepData={handleStepData}
      handleAddToCart={handleAddToCart}
      handleJumpToStep={handleJumpToStep}
      onCloseLensConfigurator={onCloseLensConfigurator}
    />
  );
};

export default LensConfiguratorView;
